module.exports = __webpack_public_path__ + "static/media/VectorPause.75bd71f2.svg";